<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-6" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Welche Medikamente nehmen Sie aktuell ein?</span>
            <p class="new-text-lg text-centered">(Langzeitblutzuckerwert)</p>
        </header>

        <div class="form-input-wrapper form-input-wrapper--wide">
            <div class="input-wrapper input-wrapper--two-column">
                <div>
                    <span class="form-input-title new-text-xl"><strong>Medikament 1</strong> <span class="new-text-lg text-color-default">(Stärke und Dosierung)</span></span>

                    <form-input-type-text
                        name="medication_1"
                        :value="medication_1 !== 'no_medication' ? medication_1 : ''"
                        :errors="errors.medication_1"
                        full-border
                    />
                </div>

                <div>
                    <span class="form-input-title new-text-xl"><strong>Medikament 2</strong> <span class="new-text-lg text-color-default">(Stärke und Dosierung)</span></span>

                    <form-input-type-text
                        name="medication_2"
                        :value="medication_2 !== 'no_medication' ? medication_2 : ''"
                        full-border
                    />
                </div>
            </div>

            <div class="input-wrapper input-wrapper--two-column">
                <div>
                    <span class="form-input-title new-text-xl"><strong>Medikament 3</strong> <span class="new-text-lg text-color-default">(Stärke und Dosierung)</span></span>

                    <form-input-type-text
                        name="medication_3"
                        :value="medication_3 !== 'no_medication' ? medication_3 : ''"
                        full-border
                    />
                </div>

                <div>
                    <span class="form-input-title new-text-xl"><strong>Medikament 4</strong> <span class="new-text-lg text-color-default">(Stärke und Dosierung)</span></span>

                    <form-input-type-text
                        name="medication_4"
                        :value="medication_4 !== 'no_medication' ? medication_4 : ''"
                        full-border
                    />
                </div>
            </div>

            <span class="form-input-title new-text-xl text-bold">Weitere Medikamente, die ich aktuell einnehme (oder weitere Anmerkungen zu meinem Medikamentenplan):</span>

            <form-input-type-text
                name="medication_info"
                :value="medication_info !== 'no_medication' ? medication_info : ''"
                full-border
                margin-bottom-double
            />

            <form-input-type-checkbox
                name="medication_check"
                label="Ich nehme aktuell keine Medikamente ein"
                :value="hasMedication === false ? true : false"
                full-border
            />

            <v-button
                label="Weiter"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                full-width
            ></v-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                errors: {},
                isDisabled: true,
                noMedicationCheck: false,
                medication_1: this.data && this.data.medication_1,
                medication_2: this.data && this.data.medication_2,
                medication_3: this.data && this.data.medication_3,
                medication_4: this.data && this.data.medication_4,
                medication_info: this.data && this.data.medication_info
            }
        },

        mounted() {
            const that = this
            const checkbox = document.getElementById('medication_check')

            checkbox.addEventListener('change', function() {
                if(checkbox.checked) {
                    that.errors = {
                        medication_1: null
                    }
                    that.$forceUpdate();
                }
            })

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        computed: {
            hasMedication() {
                if(this.data && (typeof this.data.has_medication !== 'undefined')) {
                    if(this.data.has_medication === 'true') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return undefined
                }
            }
        },

        methods: {
            onClickButton() {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                }
            },
            validate() {
                const checkbox = document.getElementById('medication_check')

                if(!checkbox.checked) {
                    if($("#medication_1").val() == "") {
                        this.errors.medication_1 = ["Geben Sie mindestens ein Medikament an oder wählen Sie unten aus, dass Sie keine Medikamente einnehmen."]
                        this.isDisabled = true
                    }

                    if($("#medication_1").val() !== "") {
                        this.errors = {
                            medication_1: null
                        }
                        this.isDisabled = false
                    }
                } else {
                    this.errors = {
                        medication_1: null
                    }
                    this.isDisabled = false
                }

                this.noMedicationCheck = checkbox.checked

                this.$forceUpdate();
            },
            submit() {
                const medications = document.querySelectorAll('.form-input-text input')

                var data = {
                    uuid: this.uuid,
                    answers: {
                        medication_check: {
                            key: 'has_medication',
                            value: this.noMedicationCheck === false ? 'true' : 'false'
                        },
                        last_tab: {
                            key: 'last_tab',
                            value: this.type === 'first' ? '7' : '5'
                        }
                    }
                }

                if(!this.noMedicationCheck) {
                    medications.forEach((medication, index) => {
                        if(medication.value !== '') {
                            data.answers[medication.name] = {key: medication.name, value: medication.value}
                        }
                    })
                } else {
                    medications.forEach((medication, index) => {
                        data.answers[medication.name] = {key: medication.name, value: 'no_medication'}
                    })
                }

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            saveData() {
                const medications = document.querySelectorAll('.form-input-text input')
                const checkbox = document.getElementById('medication_check')
                this.noMedicationCheck = checkbox ? checkbox.checked : null

                var data = {
                    answers: {
                        medication_check: {
                            key: 'has_medication',
                            value: this.noMedicationCheck === false ? 'true' : 'false'
                        }
                    }
                }

                if(!this.noMedicationCheck) {
                    medications.forEach((medication, index) => {
                        if(medication.value !== '') {
                            data.answers[medication.name] = {key: medication.name, value: medication.value}
                        }
                    })
                } else {
                    medications.forEach((medication, index) => {
                        data.answers[medication.name] = {key: medication.name, value: 'no_medication'}
                    })
                }

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>
